import { useState, useEffect } from "react";
import { Card, Form, Input, Button, Row, Col, Typography } from "antd";
import { useNavigate, useParams } from "react-router-dom";
import './Signup.css'; // Use Signup.css for styling
import { encode, decode } from '../middleware/encoding';
import { encryptData, decryptData } from '../middleware/encryption';

export default function Verification() {
  const [form] = Form.useForm();
  const navigate = useNavigate();
  const { email_verify } = useParams();
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (email_verify) {
      setEmail(decode(email_verify));
    }
  }, [email_verify]);

  const handleSubmit = (values) => {
    setLoading(true);
    const encryptedData = encryptData({
      email: email,
      otp: values.verificationCode
    });

    const myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/json");

    const requestOptions = {
      method: "POST",
      headers: myHeaders,
      body: JSON.stringify({ data: encryptedData }),
      redirect: "follow"
    };

    fetch("https://api.app.exellius.com/api/auth/verify-otp", requestOptions)
      .then((response) => response.json())
      .then((result) => {
        setLoading(false);
        if (result.data) {
          const decryptedResponse = decryptData(result.data);
          if (decryptedResponse.message === "OTP verified successfully") {
            navigate('/login');
          } else {
            console.log("Decrypted Response:", decryptedResponse);
          }
        } else {
          console.log("Response Data (Not Encrypted):", result);
        }
      })
      .catch((error) => {
        setLoading(false);
        console.error(error);
      });
  };

  return (
    <Row className="signup-container">
      {/* Left Side - Form */}
      <Col xs={24} md={12} className="signup-form-container">
        <Card className="signup-card">
          <div className="signup-logo">
            <img style={{height:"50px",width:"auto"}} src="https://res.cloudinary.com/dttmahifk/image/upload/v1739098503/partner/Lead_Finder_2_ue2r5w.png" alt="Logo" />
          </div>
          <Typography.Title level={2} className="verification-title" style={{color:"black",fontWeight:900}}>Verify Account</Typography.Title>
          <Form form={form} onFinish={handleSubmit} layout="vertical">
            <Form.Item name="verificationCode" label="Verification Code" rules={[{ required: true, len: 6, message: "Please enter the 6-character verification code" }]}> 
              <Input size="large" placeholder="Enter verification code" maxLength={6} />
            </Form.Item>
            <Form.Item>
              <Button type="primary" htmlType="submit" size="large" className="verification-button" block loading={loading}>Verify</Button>
            </Form.Item>
            <Form.Item>
              <Button type="default" size="large" className="verification-button" block onClick={() => navigate('/signup')}>Back to Signup</Button>
            </Form.Item>
          </Form>
        </Card>
      </Col>

      {/* Right Side - Image */}
      <Col xs={0} md={12} className="signup-image-container">
        <div>
          <img src="https://app.success.ai/static/media/section1-3.39df0c32ebe092599f26.png" alt="Right Side" className="signup-image" />
          <div className="verification-text-container">
            <Typography.Title level={3} className="signup-text-title">Secure your account with verification</Typography.Title>
            <Typography.Text className="signup-text">Enter the verification code sent to your email to complete the signup process and secure your account.</Typography.Text>
          </div>
        </div>
      </Col>
    </Row>
  );
}
